import { render, staticRenderFns } from "./shipmentDetails.vue?vue&type=template&id=b1c4d818&scoped=true&"
import script from "./shipmentDetails.vue?vue&type=script&lang=js&"
export * from "./shipmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c4d818",
  null
  
)

export default component.exports